import { RTFConfigurationManagementAction, RTFConfigurationManagementActions, RTFConfigurationManagementState } from "./types"

const initialState: RTFConfigurationManagementState = {
    files: [],
  }

export default function(state = initialState, action: RTFConfigurationManagementAction) {
  switch (action.type) {
    case RTFConfigurationManagementActions.setFiles:
      return { ...state, files: action.payload }

    case RTFConfigurationManagementActions.clearConfigManagementState: 
      return { ...initialState }

    default:
      return { ...state }
  }
}
